import React from 'react';
import AppLayout from '../components/AppLayout';
import OverviewList,{MiniList} from '../components/OverviewList';
import {PageMenu,DeleteListItem,GenerateSpreadsheet,
        DownloadTemplate,DynamicListArea,BulkEdit,
        LoadGraphic,AddListItem,Step,Dropzone} from '../components/Common';
import {Input,TextButton,Button,Checkbox,MiniMinusButton, PageSelector} from '../components/Input';
import u from '../utilities/Utilities';
import {Photo} from '../data/Mimetypes';
import '../styles/elearning-modules.scss';
import {Link} from 'react-router-dom';

export default class ELearningModuleList extends React.Component{
    r={};

    settings={
        /**** Page Setup ****/
        title:"E-Learning Modules",
        permission:"course",          //Accepts combined permission module as well
        //combinedField:"",   //Used when permission exists in a combined field
        url:"/e-learning-module-list",

        /**** Action Setup ****/
        addType:0,
        addURL:"/api/create-e-learning-module-entries",
        deleteURL:"/api/delete-e-learning-module-entries",
        spreadsheetURL:"/api/generate-e-learning-module-spreadsheet",
        overviewURL:"/api/get-all-e-learning-module-entries",

        /**** List Setup ****/
        list:true,
        listLabel:"e-learning-module-list",
        orderByField:"createdOn",
        orderByType:"descending",
        numRows:20,
        checkboxPermissions:{},
        overview:undefined,
        layout:()=>{return this.r['layout']},
        onPopup:(e)=>{this.r['layout'].onPopup(e)},
        onCancelPopup:(e)=>{this.r['layout'].onCancelPopup(e)}
    };

    pageComponents={
        add:{component:AddEntry,props:{}},
        delete:{component:DeleteListItem,props:{}},
        spreadsheet:{component:GenerateSpreadsheet,props:{}},
        bulkEdit:{component:BulkEdit,props:{}},
    };

    state={
        selected:{
            tags:[],
            all:false,
            data:[],
            entryCount:0
        },
        pageMenuButtons:[],
        permissions:{},
    };

    componentDidMount=()=>{
        const permissions = u.getPermissions(this.settings.permission);
        const bulkEditOptions = u.getBulkEdit(this.settings.listLabel);
        const bulkEditEnabled = (permissions.update == 2 && bulkEditOptions.length > 0);
        this.setState({
            permissions:permissions,
            pageMenuButtons:[
                {label:"Add Entry",ref:"add",enabled:(permissions.create==2)},
                {label:"Delete Entries",ref:"delete",enabled:(permissions.delete==2)},
                {label:"Generate Spreadsheet",ref:"spreadsheet",enabled:true},
                {label:"Bulk Edit",ref:"bulkEdit",enabled:bulkEditEnabled,padding:"3px"},
            ]
        });

        //this.getCourseOptions();
    };

    onSelectChange=(selected)=>{
        this.setState({selected:selected});
    };

    onCloneEntry=(content)=>{
        let clone=JSON.parse(JSON.stringify(content));
        let entryData={
            reference:clone.reference,
            order:clone.order,
        };
        for(var i=0; i<clone.localization.length; i++){
            entryData[clone.localization[i].language]=clone.localization[i].label;
        }
        this.r['pageMenu'].toggleForm("add",true);
        this.r['pageMenu'].getRef("add").editEntry(clone,entryData);
    }

    render=()=>{
        return (
            <AppLayout ref={(ref)=>{this.r["layout"]=ref}} settings={this.settings}>

                <div className="page-error">{this.state.error}</div>

                <PageMenu ref={(ref)=>{this.r['pageMenu']=ref}}
                          buttons={this.state.pageMenuButtons}
                          settings={this.settings}
                          components={this.pageComponents}
                          selected={this.state.selected}
                          />

                <OverviewList ref={(ref)=>{this.settings.overview=ref}}
                              settings={this.settings}
                              onSelectChange={this.onSelectChange}
                              registerReference={this.registerReference}
                              onMutatedChange={this.onMutatedChange}
                              location={this.props.location}>
                    {
                        (content,index,onChange,onContentChange,registerRef)=>{
                            return (
                                <ListItem key={index}
                                          index={index}
                                          content={content}
                                          onChange={onChange}
                                          onContentChange={onContentChange}
                                          registerReference={registerRef}
                                          permissions={this.state.permissions}
                                          settings={this.settings}
                                          onCloneEntry={this.onCloneEntry}
                                          />
                            )
                        }
                    }
                </OverviewList>
            </AppLayout>
        )
    }
}

class ListItem extends React.Component{
    r={};

    state={
        error:"",
        step:"view",
        loading:false,
        loadText:"",
        topicCourses:[],
        topicFields:[],
        showFullTopic:false,
        editIndex:-1,
        activeCourses:[],
    };

    onRemoveTopic=(index)=>{
        const {settings,content}=this.props;

        const confirm=async ()=>{
            settings.onCancelPopup();
            let newTopics = JSON.parse(JSON.stringify(content.topics));
            newTopics.splice(index,1);
            this.onUpdateTopics(newTopics);
        }

        settings.onPopup({
            confirm:confirm,
            cancel:()=>{settings.onCancelPopup()},
            title:"Confirm Remove Topic?",
            description:"Note. This action cannot be undone",
        });
    }

    onReorderTopic=(index)=>{
        const {settings,content}=this.props;

        const confirm=()=>{
            settings.onCancelPopup();
            let newTopics = JSON.parse(JSON.stringify(content.topics));
            const toMove = newTopics.splice(index,1);
            newTopics.splice(index-1,0,toMove[0]);
            this.onUpdateTopics(newTopics);
        }

        settings.onPopup({
            confirm:confirm,
            cancel:()=>{settings.onCancelPopup()},
            title:"Confirm Reorder Topic?",
            description:"Note. This action cannot be undone",
        });
    }

    onViewCourse=async (index)=>{
        this.setState({loading:true,loadText:"Preparing..."});
        const {content}=this.props;
        const courses = content.topics[index].courses.slice(0);

        this.setState({
            courseTopic:index,
            topicCourses:courses,
            step:"course-order",
            error:"",
            changesMade:false,
        });

        try{
            const response = await u.postAsync({
                url:"/api/get-active-courses",
                data:{
                    moduleID:content.moduleID,
                    testDelay:2000,
                }
            });
            this.setState({
                activeCourses:response.data,
                courseTopic:index,
                topicCourses:courses,
                step:"course-order",
                error:"",
                changesMade:false,
                loading:false,
            });
        }
        catch(e){
            const {error,status}=u.processError(e);
            this.setState({error:error,loading:false});
        }
    }

    onChangeCourse=(value,label,index)=>{
        const {topicCourses,activeCourses}=this.state;
        if(value){
            //Add to list
            topicCourses.push(activeCourses[index].courseID);
        }
        else{
            //Remove from list
            const tcIndex=topicCourses.indexOf(activeCourses[index].courseID);
            topicCourses.splice(tcIndex,1);
        }
        this.setState({topicCourses:topicCourses,changesMade:true});
    }

    onReorderCourse=(index)=>{
        const {topicCourses}=this.state;
        const toMove = topicCourses.splice(index,1);
        topicCourses.splice(index-1,0,toMove[0]);
        this.setState({topicCourses:topicCourses,changesMade:true});
    }

    onConfirmCourse=()=>{
        const {content}=this.props;
        const {courseTopic,topicCourses}=this.state;
        let newTopics=JSON.parse(JSON.stringify(content.topics));
        newTopics[courseTopic].courses=topicCourses;
        this.onUpdateTopics(newTopics);
    }

    onConfirmAddTopic=async (fields)=>{
        this.setState({error:""});
        let data=[];
        const keys=fields.map((item)=>{
            return item.field;
        });
        for(var i=0; i<keys.length; i++){
            const current=this.r[keys[i]].validate();
            if(!current.valid){
                this.setState({error:current.value});
                return 0;
            }
            data.push({
                language:keys[i],
                label:current.value
            });
        }

        this.setState({loading:true,loadText:"Updating..."});

        try{
            const {content}=this.props;
            const {editIndex}=this.state;

            if(editIndex==-1){
                const response=await u.postAsync({
                    url:"/api/e-learning-module-add-topic",
                    data:{
                        moduleID:content.moduleID,
                        localization:data
                    }
                });
                content.topics.push(response.data);
                this.props.onChange(content.topics,"topics",this.props.index);
                this.setState({step:"view",loading:false});
            }
            else{
                let newTopics = JSON.parse(JSON.stringify(content.topics));
                newTopics[editIndex].localization=data;
                this.onUpdateTopics(newTopics);
            }
        }
        catch(e){
            const {error,status}=u.processError(e);
            this.setState({error:error,loading:false});
        }
    }

    onAddRequest=(values,index)=>{
        const {content}=this.props;
        const topicFields=content.localization.map((item,index)=>{
            return {
                dataType:"box",
                label:"Topic Title - " + item.language,
                field:item.language,
                rules:{
                    required:(index==0),
                    placeholder:(index==0) ? "Default" : "Optional",
                    defaultValue:(values) ? values[item.language] : undefined
                },
            }
        });
        this.setState({
            step:"new-topic",
            topicFields:topicFields,
            error:"",
            editIndex:u.notNull(index) ? index : -1,
        });
    }

    onUpdateTopics=async (newTopics)=>{
        const {content}=this.props;
        try{
            this.setState({loading:true,loadText:"Updating..."});
            const response = await u.postAsync({
                url:"/api/update-e-learning-module-info",
                data:{
                    moduleID:content.moduleID,
                    oldValue:content.topics,
                    newValue:newTopics,
                    field:"topics"
                }
            });
            this.props.onChange(newTopics,"topics",this.props.index);
            this.setState({loading:false,error:"",step:"view"});
        }
        catch(e){
            const {error,status}=u.processError(e);
            this.setState({error:error,loading:false});
        }
    }

    onEditTopic=(index)=>{
        const {content}=this.props;
        const topic=content.topics[index];
        let tx = {};
        for(var i=0; i<topic.localization.length; i++){
            tx[topic.localization[i].language]=topic.localization[i].label;
        }
        this.onAddRequest(tx,index);
    }

    onPublish=async ()=>{
        this.setState({error:"",loading:true,loadText:"Publishing..."});
        try{
            const {content}=this.props;
            const response=await u.postAsync({
                url:"/api/e-learning-module-publish",
                data:{
                    moduleID:content.moduleID
                }
            })
            for(var key in response.data){
                this.props.onChange(response.data[key],key,this.props.index);
            }
            this.setState({step:"view",loading:false,error:""});
        }
        catch(e){
            const {error,status}=u.processError(e);
            this.setState({error:error,loading:false});
        }
    }

    onInactive=async ()=>{
        this.setState({error:"",loading:true,loadText:"Inactivating..."});
        try{
            const {content}=this.props;
            const response=await u.postAsync({
                url:"/api/e-learning-module-inactivate",
                data:{
                    moduleID:content.moduleID
                }
            })
            for(var key in response.data){
                this.props.onChange(response.data[key],key,this.props.index);
            }
            this.setState({step:"view",loading:false,error:""});
        }
        catch(e){
            const {error,status}=u.processError(e);
            this.setState({error:error,loading:false});
        }
    }

    onUploadPhoto=async(url)=>{
        try{
            const {content}=this.props;
            await u.postAsync({
                url:"/api/commit-module-photo",
                data:{
                    filename:url,
                    moduleID:content.moduleID
                }
            });
            this.props.onChange(url,"image",this.props.index);
            this.setState({loading:false,step:"view",error:""});
        }
        catch(e){
            const {error,status}=u.processError(e);
            this.setState({error:error,loading:false});
        }
    }

    render=()=>{
        const {content,settings,permissions} = this.props;
        const {step,changesMade,topicFields,topicCourses,showFullTopic}=this.state;
        const canEdit = (permissions.update==2 && content.status != "Live");

        return (
            <div style={{textAlign:"center"}}>
                <LoadGraphic active={this.state.loading} text={this.state.loadText}/>
                <div className="list-segment-error">{this.state.error}</div>

                <Step active={step=="view"}>
                    <DynamicListArea listLabel={settings.listLabel}
                                     permission={settings.permission}
                                     content={content}
                                     onChange={this.props.onChange}
                                     index={this.props.index}
                                     />

                    {
                        (content.image)
                            ?
                            <div style={{textAlign:"center",margin:"30px auto"}}>
                                <h3>Module Icon</h3>
                                <div style={{width:"100px",padding:"15px 10px 10px 10px",backgroundColor:"lightgrey",borderRadius:10,margin:"auto"}}>
                                    <img src={content.image} style={{width:"50px",height:"50px",borderRadius:"50%",backgroundColor:"white"}} object-fit="contain"/>
                                </div>
                            </div>
                            :
                            null
                    }

                    <div>
                        <h3>Module Topics</h3>
                        <TopicTable content={content}
                                    canEdit={canEdit}
                                    onRemove={this.onRemoveTopic}
                                    onReorder={this.onReorderTopic}
                                    onCourse={this.onViewCourse}
                                    onEdit={this.onEditTopic}
                                    showFull={showFullTopic}
                                    />

                        <div style={{margin:"20px auto"}}>
                            <TextButton onClick={()=>{this.setState({showFullTopic:!showFullTopic})}}>{(showFullTopic) ? "Hide" : "Show"} Translations</TextButton>
                        </div>

                        <div style={{margin:"20px auto"}}>
                            {
                                (permissions.create==2)
                                    ?
                                    <Button onClick={()=>{this.props.onCloneEntry(content)}}>Clone Entry</Button>
                                    :
                                    null
                            }
                            {
                                (canEdit)
                                    ?
                                    <Button onClick={()=>{this.onAddRequest()}}>Add Topic</Button>
                                    :
                                    null
                            }
                        </div>

                        {
                            (permissions.update==2)
                                ?
                                <div style={{margin:"10px auto"}}>
                                    <TextButton onClick={()=>{this.setState({step:"photo",error:""})}}>Attach/Replace Photo</TextButton>
                                    {
                                        (content.status == "Live")
                                            ?
                                            <TextButton onClick={()=>{this.setState({step:"inactive",error:""})}}>Inactivate Module</TextButton>
                                            :
                                            <TextButton onClick={()=>{this.setState({step:"publish",error:""})}}>Publish Module</TextButton>
                                    }
                                </div>
                                :
                                null
                        }

                    </div>
                </Step>

                <Step active={step=="course-select"}>
                    <h3>Courses for {content.topics[this.state.courseTopic]?.localization[0].label}</h3>
                    <CourseTableSelect content={topicCourses}
                                       activeCourses={this.state.activeCourses}
                                       onChange={this.onChangeCourse}
                                       canEdit={canEdit}
                                       />
                    <div style={{margin:"20px auto"}}>
                        <Button onClick={()=>{this.setState({error:"",step:"course-order"})}}>Next</Button>
                    </div>
                </Step>

                <Step active={step=="course-order"}>
                    <h3>Courses for {content.topics[this.state.courseTopic]?.localization[0].label}</h3>
                    <CourseTableOrder content={topicCourses}
                                      activeCourses={this.state.activeCourses}
                                      onReorderCourse={this.onReorderCourse}
                                      canEdit={canEdit}
                                      />
                    {
                        (canEdit)
                            ?
                            <div style={{margin:"20px auto"}}>
                                <TextButton onClick={()=>{this.setState({step:'course-select',error:""})}}>Update Courses</TextButton>
                            </div>
                            :
                            null
                    }

                    <div style={{margin:"20px auto"}}>
                        <Button onClick={()=>{this.setState({error:"",step:"view"})}}>Back</Button>
                        {
                            (canEdit)
                                ?
                                <Button onClick={this.onConfirmCourse} enabled={canEdit && changesMade}>Apply Changes</Button>
                                :
                                null
                        }
                    </div>
                </Step>

                <Step active={step=="new-topic"}>
                    <div style={{position:"relative",fontSize:"14px",textAlign:'center'}}>
                        <h3>Complete the following fields to create topic</h3>
                        {
                            topicFields.map(
                                (item,index)=>{
                                    return (
                                        <Input key={index}
                                               ref={(ref)=>{this.r[item.field]=ref}}
                                               values={{options:item.options}}
                                               fields={item}
                                               rules={item.rules}
                                               labelStyle={{width:"40%"}}
                                               inputStyle={{width:"57%"}}
                                               />
                                    )
                                }
                            )
                        }

                        <div className='segment-note' style={{margin:"30px auto 0 auto"}}>
                            Note. If an optional language is left empty, system will fallback to the 'Default' language
                        </div>

                        <div style={{margin:"20px auto"}}>
                            <div className='page-error'>{this.state.error}</div>
                            <Button onClick={()=>{this.setState({step:"view",error:""})}}>Cancel</Button>
                            <Button onClick={()=>{this.onConfirmAddTopic(topicFields)}}>Confirm</Button>
                        </div>
                    </div>
                </Step>

                <Step active={step=="publish"}>
                    <div style={{position:"relative",padding:"30px 0",textAlign:"center"}}>
                        <h2 className='text-negative'>Confirm Publish Module?</h2>
                        <div style={{margin:"20px auto"}}>
                            Note. Module will be visible to all users until it is set to inactive
                        </div>
                        <div style={{margin:"20px auto"}}>
                            <div className='page-error'>{this.state.error}</div>
                            <Button onClick={()=>{this.setState({step:"view",error:""})}}>Back</Button>
                            <Button onClick={this.onPublish}>Confirm</Button>
                        </div>
                    </div>
                </Step>

                <Step active={step=="inactive"}>
                    <div style={{position:"relative",padding:"30px 0",textAlign:"center"}}>
                        <h2 className='text-negative'>Confirm Inactive Module?</h2>
                        <div style={{margin:"20px auto"}}>
                            Note. Module will be removed from all users until it is published again
                        </div>
                        <div style={{margin:"20px auto"}}>
                            <div className='page-error'>{this.state.error}</div>
                            <Button onClick={()=>{this.setState({step:"view",error:""})}}>Back</Button>
                            <Button onClick={this.onInactive}>Confirm</Button>
                        </div>
                    </div>
                </Step>

                <Step active={step=="photo"}>
                    <div style={{position:"relative",textAlign:"center"}}>
                        <Dropzone label="dropzone"
                                  accessibleForPreview={true}
                                  onAdded={()=>{this.setState({loading:true,loadText:"Uploading..."})}}
                                  onUploaded={this.onUploadPhoto}
                                  onError={(error)=>{this.setState({error:error})}}
                                  onProgress={(value)=>{this.setState({loadText:"Uploading..."+value+"%"})}}
                                  filetypes={Photo}
                                  />
                        <div style={{margin:"20px auto"}}>
                            <Button onClick={()=>{this.setState({step:"view",error:""})}}>Back</Button>
                        </div>
                    </div>
                </Step>
            </div>
        )
    }
}

class AddEntry extends React.Component{

    settings={
        addType:0,
        addURL:"/api/create-e-learning-module-entry",
    };

    r={};

    state={
        step:"add",
        entryData:{},
        options:{},
        inputAddon:[],
        clone:{},
    }

    show=(show)=>{
        this.r[this.props.reference].show(show);
        if(!show){
            this.setState({
                error:"",
                clone:{},
                entryData:{}
            });
        }
    }

    componentDidMount=()=>{
        this.getOptions();
        this.show(this.props.active);
    }

    getOptions=async ()=>{
        try{
            const response=await u.postAsync({
                url:"/api/get-options",
                data:{
                    keys:[
                        "eLearningLanguage"
                    ]
                }
            });

            const languages=response.data.eLearningLanguage;

            this.setState({
                options:response.data,
                inputAddon:languages.map((item,index)=>{
                    return {
                        dataType:"box",
                        label:"Module Title - " + item.value,
                        field:item.value,
                        rules:{
                            required:(index==0),
                            placeholder:(index==0) ? "Default" : "Optional",
                        },
                        info:"Module title is displayed on the mobile app in the respective language and is selected to view the module's topics",
                        localization:true,
                    };
                }),
            });
        }
        catch(e){
            const {error,status}=u.processError(e);
            this.setState({error:error});
        }
    }

    onCancel=()=>{
        this.props.onToggleForm(this.props.reference,false);
    }

    onConfirm=(fields)=>{
        const keys = fields.map((item)=>{return item.field});
        let data = {
            localization:[],
        };

        for(var i=0; i<keys.length; i++){
            if(this.r[keys[i]]){
                const current=this.r[keys[i]].validate();
                if(!current.valid){
                    this.setState({error:current.value});
                    return 0;
                }
                if(fields[i].localization){
                    data.localization.push({
                        language:fields[i].field,
                        label:current.value,
                    });
                }
                else{
                    data[keys[i]]=current.value;
                }
            }
        }
        this.settings.overview=this.props.settings.overview;
        this.r[this.props.reference].onValidated({...data,topics:this.state.clone.topics,image:this.state.clone.image});
    }

    onComplete=()=>{
        this.setState({
            entryData:{},
            clone:{},
            step:"add"
        });

        if(this.props.onComplete){
            this.props.onComplete();
        }
    }

    onChange=(value,label,index)=>{
        let {entryData}=this.state;
        entryData[label]=value;
        this.setState({entryData:entryData});
    }

    editEntry=(content,entryData)=>{
        this.setState({
            clone:content,
            entryData:entryData,
            error:"",
        });
    }

    render=()=>{
        const {loading,loadText,step,clone,entryData,inputAddon}=this.state;

        const fields=[
            {dataType:"box",label:"Module Reference",field:"reference",rules:{required:true},info:"Reference is for internal administrative use and not displayed to the App User. It is recommended to store information such as version numbers in the module's reference for administrative purposes."},
        ].concat(inputAddon);

        return (
            <AddListItem ref={(ref)=>{this.r[this.props.reference]=ref}}
                         reference={this.props.reference}
                         settings={this.settings}
                         onComplete={this.onComplete}
                         uploadAsJson={false}
                         inList={this.props.miniList}
                         onToggleForm={this.props.onToggleForm}
                         >

                <div className='segment-content'>
                    <LoadGraphic active={loading} text={loadText}/>
                    <Step active={step=="add"}>
                        <h3>Complete the following fields to create module</h3>

                        {
                            (clone?.reference)
                                ?
                                <div style={{margin:"20px auto"}} className='text-emphasis'>
                                    Topics will be cloned from entry {clone.reference}
                                </div>
                                :
                                null
                        }

                        {
                            fields.map(
                                (item,index)=>{
                                    return (
                                        <Input key={index}
                                               ref={(ref)=>{this.r[item.field]=ref}}
                                               values={{
                                                    options:item.options,
                                                    value:entryData[item.field]
                                               }}
                                               fields={{
                                                ...item,
                                                onChange:this.onChange
                                               }}
                                               rules={item.rules}
                                               labelStyle={{width:"40%"}}
                                               inputStyle={{width:"57%"}}
                                               />
                                    )
                                }
                            )
                        }

                        <div className='segment-note' style={{margin:"30px auto 0 auto"}}>
                            Note. If an optional language is left empty, system will fallback to the 'Default' language
                        </div>

                        <div style={{margin:"20px auto"}}>
                            <div className='page-error'>{this.state.error}</div>
                            <Button onClick={this.onCancel}>Cancel</Button>
                            <Button onClick={()=>{this.onConfirm(fields)}}>Confirm</Button>
                        </div>
                    </Step>

                    <Step active={step=="add-attachment"}>
                        <Dropzone label={"Photo"}
                                  accessibleForPreview={true}
                                  onAdded={(filename)=>{this.userFilename = filename; this.setState({loading:true,loadText:"Uploading..."})}}
                                  onUploaded={this.onAddAttachment}
                                  onError={(error)=>{this.setState({error:error,loading:false})}}
                                  onProgress={(value)=>{this.setState({loadText:"Uploading..." + value + "%"})}}
                                  filetypes={Photo}
                                  />

                        <div className="segment-buttons">
                            <Button onClick={()=>{this.setState({step:"add",error:""})}}>Back</Button>
                        </div>
                    </Step>
                </div>

            </AddListItem>
        )
    }
}

class TopicTable extends React.Component{

    pageLength = 10.0;

    state={
        page:1,
        startIndex:0,
        endIndex:this.pageLength,
    }

    onChangePage=(newPage)=>{
        const startIndex = (newPage-1) * parseInt(this.pageLength);
        const endIndex = startIndex + parseInt(this.pageLength);
        this.setState({
            page:newPage,
            startIndex:startIndex,
            endIndex:endIndex
        });
    }

    convertToObj=(localization)=>{
        let obj = {};
        for(var i=0; i<localization.length; i++){
            obj[localization[i].language] = localization[i].label;
        }
        return obj;
    }

    render=()=>{
        const {content,canEdit,showFull}=this.props;
        const {page,startIndex,endIndex}=this.state;
        const maxPage = Math.ceil(content.topics.length / this.pageLength);
        const totalCourses = content.topics.map((item)=>{
            return item.courses.length;
        }).reduce((a,b)=>a+b,0);

        if(content.topics.length == 0){
            return (
                <div className='list-placeholder'>
                    <b>No Topics Added</b>
                    <div>Click below to add topic</div>
                </div>
            )
        }

        return (
            <div>
                <div className='list-table' style={{maxHeight:"none", width:(showFull) ? "96%" : undefined , margin:"auto"}}>
                    <table>
                        <thead>
                        <tr>
                            <th className='table-short left'/>
                            <th className='table-short'/>
                            <th className='table-short'/>
                            {
                                content.localization.map(
                                    (item,index,arr)=>{
                                        if(index > 0 && !showFull){
                                            return null;
                                        }
                                        return (
                                            <th key={index}>{item.language}</th>
                                        )
                                    }
                                )
                            }
                            {
                                (!showFull)
                                    ?
                                    <th>Translations (up to {content.localization.length - 1})</th>
                                    :
                                    null
                            }
                            <th className="right" style={{width:"75px"}}>Courses</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td className='table-short'/>
                            <td className='table-short'/>
                            <td className='table-short'/>
                            {
                                content.localization.map(
                                    (item,index)=>{
                                        if(index > 0 && !showFull){
                                            return null;
                                        }
                                        return (
                                            <td key={index}><b>{item.label}</b></td>
                                        )
                                    }
                                )
                            }
                            {
                                (!showFull)
                                    ?
                                    <td>{content.localization.length-1} Other Languages</td>
                                    :
                                    null
                            }
                            <td>Total ({totalCourses})</td>
                        </tr>

                        {
                            content.topics.map(
                                (topic,tIndex)=>{
                                    if(tIndex < startIndex || tIndex >= endIndex){
                                        return null;
                                    }
                                    const txLabels = this.convertToObj(topic.localization);

                                    return (
                                        <tr className='item' key={tIndex}>
                                            <td className='table-short'>
                                                {
                                                    (canEdit)
                                                        ?
                                                        <MiniMinusButton onClick={()=>{this.props.onRemove(tIndex)}}/>
                                                        :
                                                        (tIndex+1)+"."
                                                }

                                            </td>
                                            <td className='table-short'>
                                                {
                                                    (canEdit)
                                                        ?
                                                        <img src="/images/input/edit.png" onClick={()=>{this.props.onEdit(tIndex)}}/>
                                                        :
                                                        null
                                                }
                                            </td>
                                            <td className='table-short'>
                                                {
                                                    (canEdit && tIndex > 0)
                                                        ?
                                                        <img src="/images/input/down-arrow.png" className='list-arrow' onClick={()=>{this.props.onReorder(tIndex)}}/>
                                                        :
                                                        null
                                                }
                                            </td>
                                            {
                                                content.localization.map(
                                                    (item,index)=>{
                                                        if(index > 0 && !showFull){
                                                            return null;
                                                        }
                                                        return (
                                                            <td key={index} className='item'>
                                                                {txLabels[item.language]}
                                                            </td>
                                                        )
                                                    }
                                                )
                                            }
                                            {
                                                (!showFull)
                                                    ?
                                                    <td>{topic.localization.length-1} Other Languages</td>
                                                    :
                                                    null
                                            }
                                            <td>
                                                <TextButton style={{margin:"0"}} onClick={()=>{this.props.onCourse(tIndex)}}>See ({topic.courses.length})</TextButton>
                                            </td>
                                        </tr>
                                    )
                                }
                            )
                        }
                        </tbody>
                    </table>
                </div>
                {
                    (maxPage > 1)
                        ?
                        <div style={{margin:"20px auto"}}>
                            <PageSelector page={page}
                                          maxPage={maxPage}
                                          onChange={this.onChangePage}
                                          />
                        </div>
                        :
                        null
                }
            </div>
        )
    }

}

class CourseTableSelect extends React.Component{

    pageLength = 10.0;

    state={
        page:1,
        startIndex:0,
        endIndex:this.pageLength
    };

    onChangePage=(newPage)=>{
        const startIndex = (newPage-1) * parseInt(this.pageLength);
        const endIndex = startIndex + parseInt(this.pageLength);
        this.setState({
            page:newPage,
            startIndex:startIndex,
            endIndex:endIndex
        });
    }

    checkSelected=(activeCourse)=>{
        return this.props.content.filter((item)=>{return item == activeCourse.courseID}).length > 0;
    }

    render=()=>{
        const {activeCourses,canEdit}=this.props;
        const {page,startIndex,endIndex}=this.state;
        const maxPage = Math.ceil(activeCourses.length / this.pageLength);
        return (
            <div className='list-table' style={{maxHeight:"none"}}>
                <table>
                    <thead>
                        <tr>
                            <th className='remove left'/>
                            <th>Course Reference</th>
                            <th>Default Title</th>
                            <th className='right' style={{width:"150px"}}>Material Type</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            activeCourses.map(
                                (item,index)=>{
                                    if(index < startIndex || index >= endIndex){
                                        return null;
                                    }
                                    const selected=this.checkSelected(item);
                                    return (
                                        <tr key={index} className='item'>
                                            <td>
                                                {
                                                    (canEdit)
                                                        ?
                                                        <Checkbox values={{value:selected}}
                                                                  onChange={this.props.onChange}
                                                                  field="selected"
                                                                  index={index}
                                                                  />
                                                        :
                                                        (index+1)+"."
                                                }
                                            </td>
                                            <td>{item.reference}</td>
                                            <td>{item.materialDefaultLabel}</td>
                                            <td>{item.materialDefaultType}</td>
                                        </tr>
                                    )
                                }
                            )
                        }
                    </tbody>
                </table>
                {
                    (maxPage > 1)
                        ?
                        <div style={{margin:"20px auto"}}>
                            <PageSelector page={page}
                                          maxPage={maxPage}
                                          onChange={this.onChangePage}
                                          />
                        </div>
                        :
                        null
                }
            </div>
        )
    }
}

class CourseTableOrder extends React.Component{

    getContent=(activeCourses)=>{
        const content =  activeCourses.filter((item)=>{
            return this.props.content.indexOf(item.courseID) != -1
        }).sort((a,b)=>{
            const aIndex = this.props.content.indexOf(a.courseID);
            const bIndex = this.props.content.indexOf(b.courseID);
            return aIndex - bIndex;
        });
        return content;
    }

    render=()=>{
        const {activeCourses,canEdit}=this.props;
        const content=this.getContent(activeCourses);
        if(content.length == 0){
            return(
                 <div className='list-placeholder'>
                    <b>No Courses Added</b>
                    <div>Click below to add courses</div>
                </div>
            )
        }
        return (
            <div className='list-table' style={{maxHeight:"none"}}>
                <table>
                    <thead>
                        <tr>
                            <th className='remove left'/>
                            <th>Course Reference</th>
                            <th>Default Title</th>
                            <th style={{width:"150px"}}>Material Type</th>
                            {
                                (canEdit)
                                    ?
                                    <th className='table-short right'/>
                                    :
                                    null
                            }

                        </tr>
                    </thead>
                    <tbody>
                        {
                            content.map(
                                (item,index)=>{
                                    return (
                                        <tr key={index} className='item' >
                                            <td>{(index+1)+"."}</td>
                                            <td><Link to={"/course-list?tags=@reference("+item.reference+")"} target="_blank">{item.reference}</Link></td>
                                            <td>{item.materialDefaultLabel}</td>
                                            <td>{item.materialDefaultType}</td>
                                            {
                                                (canEdit)
                                                    ?
                                                    <td className='table-short'>
                                                        {
                                                            (index > 0)
                                                                ?
                                                                <img src="/images/input/down-arrow.png" className='list-arrow' onClick={()=>{this.props.onReorderCourse(index)}}/>
                                                                :
                                                                null
                                                        }
                                                    </td>
                                                    :
                                                    null
                                            }
                                        </tr>
                                    )
                                }
                            )
                        }
                    </tbody>
                </table>
            </div>
        )
    }
}